module.exports = __webpack_public_path__ + "static/media/032.019286d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/032.jpg
// module id = 539
// module chunks = 0